import { useEffect, useState } from 'react';

import { getEnecoBeXapiSiteApiV1AddressesLocationEligibility, CustomerTypeDto } from '@eneco/dc-be/client';
import usePublicDCBE from '@eneco/dc-be/hooks/usePublicDCBE';
import { useDebounce } from 'react-use';

const usePostalCodeBrusselsEligibilityCheck = (postalCode: string | undefined, customerType: CustomerTypeDto) => {
  const [debouncedPostalCode, setDebouncedPostalCode] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);
  const [hasMadeInitialRequest, setHasMadeInitialRequest] = useState<boolean>(false);

  const shouldFetch = Boolean(debouncedPostalCode && debouncedPostalCode.length >= 1 && postalCode);

  const [isReady] = useDebounce(
    () => {
      setDebouncedPostalCode(postalCode ?? '');
    },
    300,
    [postalCode],
  );

  const { data, isLoading } = usePublicDCBE(
    getEnecoBeXapiSiteApiV1AddressesLocationEligibility,
    { query: { postalCode: postalCode ?? '', customerType } },
    ['addresses/location-eligibility', debouncedPostalCode, customerType],
    shouldFetch,
  );

  useEffect(() => {
    if (shouldFetch && !hasMadeInitialRequest) {
      setHasMadeInitialRequest(true);
    }
  }, [shouldFetch, hasMadeInitialRequest]);

  useEffect(() => {
    const isValid = !isLoading && !!data && !('error' in data && data.error) && !!postalCode && !!isReady();
    setIsValid(isValid);
  }, [data, isLoading, isReady, postalCode]);

  return {
    isLoadingPostalCodeEligible: isLoading && !!isReady(),
    isPostalCodeEligible: isValid,
    shouldShowError: !isValid && !(isLoading && !!isReady()) && hasMadeInitialRequest && shouldFetch,
  };
};

export default usePostalCodeBrusselsEligibilityCheck;
